import React, { useEffect, useState } from "react"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"

import {
  exportProvinceConsumptionReports,
  getProvinceConsumptionReports,
} from "store/province-reports/province-report-action"
import { getProvinceItemCategories, getProvinceCurrencies } from "store/province-dashboard/province-dashboard-action"
import { getProvinceConsumptionsProviderAccount } from "store/province-consumptions/province-consumption-action"
import ProvinceConsumptionReportListComponent from "components/ProvinceReports/Consumption"

const ProvinceConsumptionReportList = ({ from }) => {
  // Metat Title
  document.title = "Consumption Reports"

  const dispatch = useDispatch()

  // Retrieve consumptions data from Redux store
  const consumptions = useSelector(
    state => state.provinceReports.provinceConsumptionReport
  )

  // Current status of the export process for the report, retrieved from the Redux store
  const exportStatus = useSelector(
    state => state.provinceReports.provinceConsumptionExport
  )

  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.PROVINCE_CONSUMPTION
  )

  const [pageNumber, setPageNumber] = useState(20)

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getProvinceConsumptionReports(
        according,
        advnacedSearch,
        pageNumber,
        link.url
      )
    )
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = number => {
    setPageNumber(number)
  }

  // fetch new data based page number or according changes
  useEffect(() => {
    dispatch(
      getProvinceConsumptionReports(
        according,
        advnacedSearch,
        pageNumber,
        undefined
      )
    )
  }, [according, pageNumber])

  // fetch item categories and provider account user for filter
  useEffect(() => {
    dispatch(getProvinceItemCategories())
    dispatch(getProvinceConsumptionsProviderAccount())
    dispatch(getProvinceCurrencies())
  }, [])

  // Updates search value when a new search is performed
  const onSearchHandler = data => {
    setAdvancedSearch(data)
    dispatch(
      getProvinceConsumptionReports(undefined, data, pageNumber, undefined)
    )
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportProvinceConsumptionReports(according, advnacedSearch, visibleKeys))
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Province"} breadcrumbItem={"Consumption Reports"} />
      {/* Province Consumption Report Component  */}
      <ProvinceConsumptionReportListComponent
        data={consumptions?.data}
        error={consumptions?.error}
        loading={consumptions?.loading}
        onChangeOrdering={onChangeOrdering}
        onSearchHandler={onSearchHandler}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
        onChangeRowNumber={onChangeRowNumber}
        onPageClick={onPageClick}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default ProvinceConsumptionReportList
